import styled from 'styled-components';
import Link from 'gatsby-link';
import { Button } from '../../../utils/atoms';
import {
  white,
  brightBlue,
  lightGrey,
  roboto,
  tekoMedium,
  openSans,
  openSansBold,
  lightBlue,
  grey,
  blue,
} from '../../../utils/theme';
import { mobile, tablet } from '../../../utils/breakpoints';
import { colorWithHover } from '../../../utils/animations';

export const Container = styled.div`
  line-height: 30px;
  font-size: 22px;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;

  @media (max-width: ${mobile.max}px) {
    padding: 0 0 40px 0;
    margin: 0;
  }
`;

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 30px auto 0 auto;
  text-align: left;
  padding: 0 30px;

  .article-card {
    height: 100%;
    
    .gatsby-image-wrapper {
      width: 100% !important;
      height: auto !important;
      max-height: 250px;
      padding-bottom: 70%;
      vertical-align: top;
    }
  }

  @media (max-width: ${mobile.max}px) {
    margin: 0;
    padding: 0;
  }
`;

export const SortMenu = styled.span`
  display: inline-block;
  font-size: 14px;
  line-height: 40px;
  margin: 0 0 20px 20px;
  color: ${lightBlue};
  letter-spacing: 2.04px;

  button {
    border: none;
    background: none;
    color: ${grey};
    ${openSans};
    cursor: pointer;
    font-size: 16px;

    &.active {
      color: ${lightBlue};
      ${openSansBold};
    }
  }

  @media (max-width: ${mobile.max}px) {
    display: none;
  }
`;

export const ListArticle = styled.div`
  position: relative;
  padding: 5px;
  flex-basis: 33%;
  height: auto;
  max-width: 370px;
  width: 30vw;

  .article-card: {
    padding: 0;
  }

  > p, div {
    width: 100%;
  }

  @media(max-width: ${tablet.max}px) {
    width: 50%;
    flex-basis: 50%;
  }
  @media(max-width: ${tablet.min}px) {
    width: 100%;
    flex-basis: 100%;
    
    .article-card {
      height: auto;
      
      .media {
        height: auto;
      }
    }
  }
`;

export const MenuWrapper = styled.menu`
  background-color: ${brightBlue};
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none; // IE 10+
  overflow: -moz-scrollbars-none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }

  @media (max-width: ${mobile.max}px) {
    margin: 0;
  }
`;

export const TabMenu = styled.div`
  display: flex;
  flex-flow: row nowrap;
  @media (max-width: ${mobile.max}px) {
    margin: 0;
  }
`;

export const FlexWrapper = styled.section`
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
  justify-content: center;
`;

export const Tab = styled.button`
  flex-basis: 25%;
  height: 50px;
  line-height: 50px;
  ${({ active }) => {
    if (active) {
      return `
        color: ${brightBlue},
        background: ${white},
      `;
    }
    return `
      color: ${white};
      background: ${brightBlue}
      ${colorWithHover({
    color: blue,
    inverse: white,
    borderWidth: '0px',
  })}`;
  }}
  color: ${({ active }) => (active ? brightBlue : white)};
  background: ${({ active }) => (active ? white : brightBlue)};
  letter-spacing: 2.98px;
  text-transform: uppercase;
  border: none;
  border-left: 1px solid ${white};
  border-right: 1px solid ${white};
  font-size: 14px;
  ${roboto};
  font-weight: bold;
  cursor: pointer;
  padding: 0px;
  margin: 0px;


  > p, div {
    width: 100%;
  }

  &:first-of-type {
    border-left: none;
  }

  &:last-of-type {
    border-right: none;
  }

  @media (max-width: ${mobile.max}px) {
    border: none;
    color: ${white};
    ${({ active }) => (active ? `background: url('/images/selected.svg') no-repeat, ${brightBlue};` : '')};
    background-position: bottom center;
  }
`;

export const MobileArticle = styled(Link)`
  padding: 30px 145px 30px 30px;
  text-align: left;
  position: relative;
  display: block;
  min-height: 160px;
  border-top: 1px solid ${lightGrey};

  .date {
    ${openSansBold}
    font-size: 12px;
    color: #050709;
    letter-spacing: 0.4px;
    line-height: 24px;
    margin-bottom: 8px;
  }

  .title {
    ${tekoMedium}
    font-size: 19px;
    color: #26397E;
    letter-spacing: 1.57px;
    line-height: 23px;
    text-transform: uppercase;
  }

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    border-bottom: 1px solid ${lightGrey};
  }

  .image {
    background: url('${({ img }) => img}');
    background-position: center center;
    background-size: cover;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 30px;
    right: 30px;
  }
`;

export const MobileAnchor = styled.a`
  padding: 30px 145px 30px 30px;
  text-align: left;
  position: relative;
  display: block;
  min-height: 160px;
  border-top: 1px solid ${lightGrey};

  .date {
    ${openSansBold}
    font-size: 12px;
    color: #050709;
    letter-spacing: 0.4px;
    line-height: 24px;
    margin-bottom: 8px;
  }

  .title {
    ${tekoMedium}
    font-size: 19px;
    color: #26397E;
    letter-spacing: 1.57px;
    line-height: 23px;
    text-transform: uppercase;
  }

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    border-bottom: 1px solid ${lightGrey};
  }

  .image {
    background: url('${({ img }) => img}');
    background-size: cover;
    background-position: top center;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 30px;
    right: 30px;
  }
`;

export const ReadMore = styled(Button)`
  display: block;
  width: 190px;
  margin: 19px auto;
  padding: 0;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 31.48px;
  letter-spacing: 3.72px;
  text-align: center;
  line-height: 6.53px;
  height: 40px;
  line-height: 40px;
`;



// WEBPACK FOOTER //
// ./src/components/article-list/styles/article-list.style.js